import { SupportedLanguage } from "./languageStorage"
import en from "@/locales/en.json"

type OverrideDict = Record<string, Record<string, string>>

const overrideSources: Partial<Record<SupportedLanguage, OverrideDict>> = { en }

// カテゴリをフラットに展開したMap（言語ごとにキャッシュ）
const flatMaps = new Map<SupportedLanguage, Map<string, string>>()

const getFlatMap = (lang: SupportedLanguage): Map<string, string> => {
    const cached = flatMaps.get(lang)
    if (cached) return cached

    const dict = overrideSources[lang]
    const map = new Map<string, string>()
    if (dict) {
        for (const category of Object.values(dict)) {
            for (const [key, value] of Object.entries(category)) {
                map.set(key, value)
            }
        }
    }
    flatMaps.set(lang, map)
    return map
}

/**
 * オーバーライド辞書から翻訳を取得する
 * context指定時は "{text}_{context}" を優先的に検索し、なければ "{text}" にフォールバック
 */
export const getOverride = (
    lang: SupportedLanguage,
    text: string,
    context?: string
): string | undefined => {
    if (lang === "ja") return undefined
    const map = getFlatMap(lang)
    if (context) {
        const contextual = map.get(`${text}_${context}`)
        if (contextual !== undefined) return contextual
    }
    return map.get(text)
}
